import React from 'react'
import { Header } from './components/header'
import { ButtonQuota } from './components/buttonQuota'
import { Destination } from '../../../../../components/destination'
import Terms from './components/terms'
import { useSelector } from 'react-redux'
import { AppState } from 'interfaces/app'
import { RootState } from 'context'

export const Quota: React.FC = () => {
    const { isMobile } = useSelector<RootState, AppState>((state) => state.app)
    return (
        <div className='size-quota quota bp-p-24'>
            <Header />
            <Terms isMobile={isMobile} />
            <Destination isMobile={isMobile} />
            <ButtonQuota />
        </div>
    )
}
